import { motion } from "framer-motion";

const variants = {
  hidden: (direction = "up") => ({
    opacity: 0,
    y: direction === "up" ? 24 : direction === "down" ? -24 : 0,
    x: direction === "left" ? 18 : direction === "right" ? -18 : 0,
  }),
  show: {
    opacity: 1,
    y: 0,
    x: 0,
    transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function Reveal({
  children,
  direction = "up",
  delay = 0,
  amount = 0.08,
  className = "",
  testId,
}) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount, margin: "0px 0px -80px 0px" }}
      custom={direction}
      variants={variants}
      transition={{ delay }}
      className={className}
      data-testid={testId}
    >
      {children}
    </motion.div>
  );
}
